import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectRoleSelectOptions } from '@ninety/platform/state/app-entities/roles/roles-state.selectors';
import { ROLE_SELECT_OPTIONS } from '@ninety/ui/core';

/**
 * Binds the `ROLE_SELECT_OPTIONS` token consumed by `InlineRoleSelectComponent` in `@ninety/ui/core`
 * to the `platform/state` role-options selector. The component stays free of any `@ninety/platform/state`
 * dependency so it can be packaged in the public API; this composition-root wiring is the single place
 * that depends on both the token and that platform lib. (DEV-26530 Part 7)
 */
export const INLINE_ROLE_SELECT_PROVIDERS: Provider[] = [
  {
    provide: ROLE_SELECT_OPTIONS,
    useFactory: (store: Store) => store.select(selectRoleSelectOptions),
    deps: [Store],
  },
];
